<div class="facet-filter-container" *ngIf="facet" [class.with-heading]="withHeading">
	<div *ngIf="withHeading && !collapsed" class="left-line left-line-gap"></div>
	<div class="facet-label-area" (click)="collapsed = !collapsed">
		<div class="in-exclude" *ngIf="withHeading && !collapsed">
			<bb-icon-toggle
				*ngIf="analyticsService.status.facetconfig && analyticsService.status.facetconfig[facet.name]"
				[(ngModel)]="analyticsService.status.facetconfig[facet.name].not"
				(ngModelChange)="onExcludeToggleChange($event)"
				[useExclude]="true"
				class="small"
				theme="dark-theme"
				color="#3693ef"
				falseColor="#7ab1df"
				[title]="(analyticsService.status.facetconfig[facet.name].not ? 'CLICK_TO_INCLUDE_SELECTION' : 'CLICK_TO_EXCLUDE_SELECTION') | translate"
			></bb-icon-toggle>
		</div>
		<ng-container *ngIf="withHeading">
			<i class="fa-solid fa-{{ collapsed ? 'square-plus' : 'square-minus' }}"></i>
			<span class="facet-label">
				{{ facet.label }}
			</span>
		</ng-container>
	</div>
	<ng-container *ngIf="!collapsed">
		<em class="no-results"
			*ngIf="(!facetData || facetData?.length === 0) && !(analyticsService.loadingData || analyticsService.loadingFacetRef[facet.name])"
			[class.left-line]="withHeading"
		>
			{{ 'NO_RESULTS_FOUND' | translate }}
			<br /><br />
		</em>
		<div class="facet-loading-container facet-values"
			*ngIf="(!facetData || facetData?.length === 0) && (analyticsService.loadingData || analyticsService.loadingFacetRef[facet.name])"
			[class.left-line]="withHeading"
		>
			<div class="facet-row">
				<div class="state">
					<bb-check
						[disabled]="true"
						class="small"
						theme="dark-theme"
						color="#3693ef"
						falseColor="#7ab1df"
					></bb-check>
				</div>
				<div class="info">
					<mat-progress-bar mode="indeterminate" class="is-new"></mat-progress-bar>
				</div>
			</div>
		</div>
		<ng-container *ngIf="facetData?.length || searchMode">
			<div class="facet-values"
				[class.left-line]="withHeading"
			>
				<div class="facet-row" *ngFor="let facetValueItem of facetData; let i = index;">
					<div class="state">
						<bb-check
							*ngIf="facetValueModels[facetValueItem.value]"
							[(ngModel)]="facetValueModels[facetValueItem.value].checked"
							(ngModelChange)="onCheckboxChange(i, $event)"
							[useExclude]="analyticsService.status.facetconfig[facet.name].not"
							class="small"
							theme="dark-theme"
							color="#3693ef"
							falseColor="#7ab1df"
						></bb-check>
					</div>
					<div class="info" [class.has-highlight]="facetValueModels[facetValueItem.value].highlighted">
						<mat-progress-bar mode="indeterminate" *ngIf="analyticsService.loadingData || analyticsService.loadingFacetRef[facet.name]"></mat-progress-bar>
						<!-- [value]="40" color="blue" -->
						<div class="percent-wrapper" *ngIf="!analyticsService.loadingData && !analyticsService.loadingFacetRef[facet.name]">
							<div class="percent-bg"></div>
							<div class="percent"
								*ngIf="!facetFilters?.length"
								[style.width]="(facetValueItem.count / total * 100) + '%'"
								[style.border-color]="(analyticsService.highlightColorRef && analyticsService.highlightColorRef[facet.name + ':' + facetValueItem.value]) || null"
							></div>
						</div>
						<div class="facet-item-name" [title]="facetValueItem.value" (click)="onFacetValueClick(i, facetValueModels[facetValueItem.value])">
							{{ facetValueItem.label || facetValueItem.value }}
							<em *ngIf="!facetValueItem.value && facetValueItem.value !== 0 && facetValueItem.value !== false" class="unknown">
								unknown
							</em>
						</div>
						<ng-container
							*ngIf="facetValueModels[facetValueItem.value]"
						>
							<a
								*ngIf="facetValueItem?.url"
								[href]="facetValueItem.url"
								target="_blank"
								class="facet-item-url"
							>
								<i class="far fa-arrow-up-right-from-square"></i>
							</a>
							<div
								*ngIf="analyticsService.facetHighlightCount >= analyticsService.maxfacetHighlightCount && !facetValueModels[facetValueItem.value].highlighted; else normalHighlight"
								class="facet-item-highlight disabled-highlight"
								title="A maximum of 6 highlights is allowed."
							>
								<i class="far fa-chart-line"></i>
							</div>
							<ng-template #normalHighlight>
								<div
									(click)="onHighlightClick(i)"
									class="facet-item-highlight normal-highlight"
									[class.active]="facetValueModels[facetValueItem.value].highlighted"
									[style.color]="(analyticsService.highlightColorRef && analyticsService.highlightColorRef[facet.name + ':' + facetValueItem.value]) || null"
								>
									<i [class.fa-solid]="facetValueModels[facetValueItem.value].highlighted" class="far fa-chart-line"></i>
								</div>
							</ng-template>
						</ng-container>
						<div
							class="facet-item-value"
							[title]="facetValueItem.count | number"
							[style.opacity]="analyticsService.loadingData || analyticsService.loadingFacetRef[facet.name] ? '0.25' : '1'"
							[class.filtered]="facetFilters?.length"
						>
							<span class="pct" *ngIf="!facetFilters?.length && !facetValueModels[facetValueItem.value].highlighted && !(analyticsService.loadingData || analyticsService.loadingFacetRef[facet.name])">
								{{ (facetValueItem.count / total) === 1 ? '100%' : ((facetValueItem.count / total) | percent:'.1') }}
							</span>
							<span class="abs">
								{{ facetValueItem.count | numberWithLetter:true }}
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="search"
				*ngIf="searchMode"
				[class.left-line]="withHeading"
			>
				<mat-form-field appearance="fill" class="full-width margin-bottom">
					<mat-label>{{'SEARCH' | translate}}</mat-label>
					<input matInput [(ngModel)]="facetSearchTerm" name="facetSearchTerm" type="text" (change)="onFacetSearchTermChange()" autofocus>
				</mat-form-field>
				<div
					*ngIf="withHeading"
					class="left-line left-line-search-gap"
				></div>
			</div>
			<div class="more-actions" *ngIf="(searchMode || facetData?.length >= 10)">
				<div
					*ngIf="facetData?.length === analyticsService.status.activeFacets[facet.name] && !(analyticsService.loadingData || analyticsService.loadingFacetRef[facet.name])"
					class="show-more" (click)="onShowMoreClick()">
					{{ 'SHOW_MORE' | translate }}
				</div>
				<div
					*ngIf="facetData?.length > 10 && facetData?.length !== analyticsService.status.activeFacets[facet.name] && !(analyticsService.loadingData || analyticsService.loadingFacetRef[facet.name]) && !hasQuerySet"
					class="show-less" (click)="onShowLessClick()">
					{{ 'SHOW_LESS' | translate }}
				</div>
				<div *ngIf="!searchMode" class="search-more" (click)="onSearchClick()">
					<i class="fa-solid fa-magnifying-glass"></i>
				</div>
				<div *ngIf="withHeading && (facetData?.length > 10 && facetData?.length !== analyticsService.status.activeFacets[facet.name] || facetData?.length === analyticsService.status.activeFacets[facet.name]) && !(analyticsService.loadingData || analyticsService.loadingFacetRef[facet.name])" class="left-line left-line-bottom-gap"></div>
			</div>
		</ng-container>
	</ng-container>
</div>
